<!--
 * @Author: Src
 * @Date: 2025-11-18 17:42:22
 * @LastEditTime: 2025-11-21 15:20:02
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/car/components/viewImage.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="c_popup" @click="onClose">
        <div class="van-overlay">
            <div>
                <div class="top_swipe">
                    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false"
                        @change="changeIndex">
                        <van-swipe-item v-for="(item, index) in shopImg" :key="index">
                            <div style="width: 100%; height: 350px; text-align: center; overflow: hidden ;">
                                <img :src="item" style="height: 350px;" />

                            </div>
                        </van-swipe-item>
                    </van-swipe>
                    <span class="swipe_span">
                        {{ `${shopImgIndex}/${shopImg.length}` }}
                    </span>
                </div>
            </div>
            <div class="name_info">{{ name }}</div>
            <div class="pice_info">{{ pice }}<span class="w_info">万</span></div>

        </div>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { Swipe, SwipeItem, Popup, Tabbar, Icon, Button } from 'vant';

@Component({
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Tabbar.name]: Tabbar,
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        [Button.name]: Button,
    },
})
export default class viewImage extends Vue {
    @Prop()
    shopImg!: any;

    @Prop()
    pice!: any;

    @Prop()
    name!: any;

    shopImgIndex: any = 1;

    changeIndex(index: number) {
        this.shopImgIndex = index + 1;
    }

    onClose() {
        this.$emit('close');
    }
}
</script>
<style scoped lang="scss">
.c_popup {
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .van-overlay {
        // display: flex;
        // justify-content: center;
        // flex-direction: column;
        // align-items: center;

        .top_swipe {
            margin-top: 20vh;
            position: relative;

            .swipe_span {
                position: absolute;
                box-sizing: border-box;
                padding: 5px 10px;
                bottom: 10px;
                right: 10px;
                color: #fff;
                font-size: 12px;
                z-index: 999;
                background: fixed rgba(0, 0, 0, .5);
            }
        }

        .name_info {
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            box-sizing: border-box;
            padding: 16px;
        }

        .pice_info {
            font-size: 16px;
            color: #FF5E33;
            box-sizing: border-box;
            padding: 16px;
            font-weight: 600;

            .w_info {
                font-size: 12px;
            }
        }
    }


}
</style>
